module.exports = new __parcel__URL__("steve-jobs.d2d147fb.jpg").toString();